<template>
	<div id="loginParentDiv">
		<div class="login-container">
			<div class="login-header">
				<h1>欢迎回来</h1>
				<p>登录您的账户，开始创作之旅</p>
			</div>

			<form class="login-form" @submit.prevent="handleSubmit">
				<div class="form-group" style="width: 300px;">
					<!-- <label for="username" style="text-align: left;">用户名或邮箱</label> -->
					<input type="text" id="username" class="form-input" placeholder="请输入用户名或邮箱"
						v-model="formData.username" :class="{ 'error': errors.username }"
						@input="clearError('username')" required>
					<div class="error-message" v-if="errors.username">{{ errors.username }}</div>
				</div>

				<div class="form-group" style="width: 300px;">
					<!-- <label for="password" style="text-align: left;">密码</label> -->
					<div class="password-container">
						<input type="password" id="password" class="form-input" placeholder="请输入密码"
							v-model="formData.password" :class="{ 'error': errors.password }"
							@input="clearError('password')" :type="showPassword ? 'text' : 'password'" required>
						<button type="button" class="toggle-password" @click="togglePassword">
							{{ showPassword ? '隐藏' : '显示' }}
						</button>
					</div>
					<div class="error-message" v-if="errors.password">{{ errors.password }}</div>
				</div>

				<div class="remember-forgot">
					<div class="remember-me">
						<input type="checkbox" id="rememberMe" v-model="formData.rememberMe">
						<label for="rememberMe">记住我</label>
					</div>
					<a href="#" class="forgot-password" @click.prevent="handleForgotPassword">忘记密码？</a>
				</div>

				<button type="submit" class="login-button" :disabled="loading">
					{{ loading ? '登录中...' : '登录' }}
				</button>

				<div class="register-link">
					还没有账户？ <a href="#" @click.prevent="handleRegister">立即注册</a>
				</div>

				<div class="social-login">
					<p>或使用以下方式登录</p>
					<div class="social-buttons">
						<button type="button" class="social-btn google" @click="socialLogin('google')">F</button>
						<button type="button" class="social-btn facebook" @click="socialLogin('facebook')">D</button>
						<button type="button" class="social-btn github" @click="socialLogin('github')">D</button>
					</div>
				</div>
			</form>
		</div>
	</div>

</template>

<script>
	import jsUtils from '../utils/jsUtils.js'
	import loginService from '../service/login.js'

	export default {
		name: 'login',
		data() {
			return {
				ButtonLoading: false, //登录按钮点击后的加载动画
				//表单属性
				sizeForm: {
					bm: '',
					pass: ''
				},
				loginClick: -1, //是否触发登录, -1为触发, 0为不触发
				keydownHandler: null, //键盘监听事件
				body: null, //文档对象
				//登录属性
				formData: {
					username: '',
					password: '',
					rememberMe: false
				},
				errors: {
					username: '',
					password: ''
				},
				showPassword: false,
				loading: false
			}
		},
		components: {},
		created() {
			// console.log("触发created");
			// 取消浏览器自带的右键菜单
			window.oncontextmenu = function(e) {
				//取消默认的浏览器自带右键
				e.preventDefault();
			}
		},
		mounted() {},
		methods: {
			togglePassword() {
				this.showPassword = !this.showPassword
			},

			clearError(field) {
				if (this.errors[field]) {
					this.errors[field] = ''
				}
			},

			validateForm() {
				let isValid = true

				if (!this.formData.username.trim()) {
					this.errors.username = '请输入用户名或邮箱'
					isValid = false
				}

				if (!this.formData.password.trim()) {
					this.errors.password = '密码不能为空'
					isValid = false
				}

				return isValid
			},
			//登录事件
			async handleSubmit() {
				if (!this.validateForm()) {
					return;
				}
				this.loading = true;
				try {
					await loginService.login(this.formData.username, this.formData.password).then(resp => {
						// console.log("登录返回>>", resp);
						if (resp) {
							if (resp.code === 200 && resp.message == "成功") {
								// console.log("进入");
								//存储登录凭证
								window.localStorage.clear();
								window.localStorage.setItem("jwt", resp.data.result);
								window.localStorage.setItem("user", JSON.stringify(resp.data.user));
								this.$router.push("/NoteTitle");
							} else {
								// console.log("执行结果异常>>", resp.message);
								this.$message({
									message: resp.message,
									type: "warning",
									duration: 2000,
									showClose: true
								});
							}
						}
					}).catch(err => {
						// console.log("登录出错!", err);
						this.$message({
							message: "出现异常情况>>" + err,
							type: "error",
							duration: 2000,
							showClose: true
						});
					});
				} catch (error) {
					console.error('登录失败:', error)
					this.errors.username = '登录失败，请检查用户名和密码'
				} finally {
					this.loading = false
				}
			},
			handleForgotPassword() {
				this.$emit('forgot-password')
			},
			handleRegister() {
				this.$emit('register')
			},
			socialLogin(provider) {
				this.$emit('social-login', provider)
			}
		},
		beforeDestroy() {
			// console.log("Login实例销毁前",this.keydownHandler);
			// this.body.removeEventListener('keydown', this.keydownHandler);
		},
	}
</script>

<style scoped>
	#loginParentDiv {
		width: 100%;
		height: 100%;
		position: relative;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	}

	.login-container {
		height: 600px;
		background: white;
		border-radius: 15px;
		box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
		width: 100%;
		max-width: 400px;
		overflow: hidden;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
	}

	.login-header {
		background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
		color: white;
		text-align: center;
		padding: 30px 20px;
	}

	.login-header h1 {
		font-size: 28px;
		margin-bottom: 10px;
		font-weight: 600;
	}

	.login-header p {
		font-size: 14px;
		opacity: 0.9;
	}

	.login-form {
		padding: 30px;
	}

	.form-group {
		margin-bottom: 20px;
	}

	.form-group label {
		display: block;
		margin-bottom: 8px;
		font-weight: 500;
		color: #333;
		font-size: 14px;
	}

	.form-input {
		width: 100%;
		padding: 12px 15px;
		border: 2px solid #e1e1e1;
		border-radius: 8px;
		font-size: 14px;
		transition: all 0.3s ease;
	}

	.form-input:focus {
		outline: none;
		border-color: #4facfe;
		box-shadow: 0 0 0 3px rgba(79, 172, 254, 0.1);
	}

	.form-input.error {
		border-color: #e74c3c;
	}

	.password-container {
		position: relative;
	}

	.toggle-password {
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		background: none;
		border: none;
		cursor: pointer;
		color: #666;
		font-size: 14px;
	}

	.remember-forgot {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 25px;
	}

	.remember-me {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.remember-me input {
		width: 16px;
		height: 16px;
	}

	.forgot-password {
		color: #4facfe;
		text-decoration: none;
		font-size: 14px;
	}

	.forgot-password:hover {
		text-decoration: underline;
	}

	.login-button {
		width: 100%;
		padding: 12px;
		background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
		color: white;
		border: none;
		border-radius: 8px;
		font-size: 16px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s ease;
	}

	.login-button:hover:not(:disabled) {
		transform: translateY(-2px);
		box-shadow: 0 5px 15px rgba(79, 172, 254, 0.3);
	}

	.login-button:active {
		transform: translateY(0);
	}

	.login-button:disabled {
		opacity: 0.7;
		cursor: not-allowed;
		transform: none;
	}

	.register-link {
		text-align: center;
		margin-top: 25px;
		font-size: 14px;
		color: #666;
	}

	.register-link a {
		color: #4facfe;
		text-decoration: none;
		font-weight: 500;
	}

	.register-link a:hover {
		text-decoration: underline;
	}

	.error-message {
		color: #e74c3c;
		font-size: 12px;
		margin-top: 5px;
	}

	.social-login {
		margin-top: 25px;
		text-align: center;
	}

	.social-login p {
		color: #666;
		font-size: 14px;
		margin-bottom: 15px;
		position: relative;
	}

	.social-login p::before,
	.social-login p::after {
		content: '';
		position: absolute;
		top: 50%;
		width: 30%;
		height: 1px;
		background: #e1e1e1;
	}

	.social-login p::before {
		left: 0;
	}

	.social-login p::after {
		right: 0;
	}

	.social-buttons {
		display: flex;
		justify-content: center;
		gap: 15px;
	}

	.social-btn {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		border: none;
		cursor: pointer;
		transition: all 0.3s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
	}

	.social-btn.google {
		background: #db4437;
		color: white;
	}

	.social-btn.facebook {
		background: #4267B2;
		color: white;
	}

	.social-btn.github {
		background: #333;
		color: white;
	}

	.social-btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
	}

	@media (max-width: 480px) {
		.login-container {
			margin: 10px;
		}

		.login-form {
			padding: 20px;
		}

		.remember-forgot {
			flex-direction: column;
			gap: 10px;
			align-items: flex-start;
		}
	}
</style>